import { Pipe, PipeTransform } from '@angular/core';

/**
 * Safe HTML pipe
 * Usage: {{ htmlContent | appSafeHtml }}
 */
@Pipe({
  name: 'appSafeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    return value.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
}
